import { useLayoutEffect } from "react";
import { useRadioByNameseo } from "../../../hooks/useApi";
import "./styles/tasks.scss";
import "./styles/task-spritz-rock-music.scss";
import "./styles/task-johnnie-music.scss";
import Task from "./Task";
import { TasksProvider } from "../../../hooks/useTasks";

export default function TaskContainer({ nameseo, onCompleted }) {
  const { getRadioQuery } = useRadioByNameseo();
  const { data } = getRadioQuery;

  useLayoutEffect(() => {
    if (nameseo) {
      document.body.classList.add(`task-${nameseo}`);
    }
    return () => {
      if (nameseo) {
        document.body.classList.remove(`task-${nameseo}`);
      }
    };
  }, [nameseo]);

  return (
    <TasksProvider initialNameseo={nameseo}>
      <div className="tasks-container">
        <Task nameseo={nameseo} onCompleted={onCompleted} {...(data ?? {})} />
      </div>
    </TasksProvider>
  );
}
